//vendors
import React, {useState, useRef, useEffect} from 'react';
import classNames from 'classnames';

//other
import {FileIcon} from "./file_icon";
import styles from './file_field.module.scss';

type Props = {
	label?: string,
	subLabel?: string,
	name?: string,
	error?: string,
	accept?: string,
	className?: string,
	valueLabel?: string,
	disabled?: boolean,
	touched?: boolean,
	required: boolean,
	onChange: (file: File) => void
};

export const FileField = (props: Props) => {
	const [fileName, setFileName] = useState(undefined);
	const inputRef = useRef(null);
	
	useEffect(() => {
		if (inputRef.current && !inputRef.current.value)  {
			setFileName(undefined);
		}
	}, [inputRef.current?.value]);
	
	const handlerOnChange = (e) => {
		setFileName(e.target.files[0].name);
		props.onChange(e.target.files[0]);
	};
	
	return (
		<div className={classNames(styles.root, props.className)}>
			{props.label &&
				<label>
					<p>{props.required && <span>* </span>}{props.label}</p>
					{props.subLabel && <p className={styles.subLabel}>{props.subLabel}</p>}
				</label>
			}
			<div className={styles.inputWrap}>
				<div className={
					classNames(
						styles.fakeInput,
						{[styles.errorInput]: !!props.error && props.touched},
						{[styles.disabled]: props.disabled}
					)
				}>
					<span>{fileName || props.valueLabel}</span>
				</div>
				<div className={classNames(styles.iconWrap, {[styles.disabled]: props.disabled})}>
					<input
						ref={inputRef}
						name={props.name}
						type="file"
						accept={props.accept}
						disabled={props.disabled}
						onChange={handlerOnChange}
					/>
					<FileIcon/>
				</div>
				{props.touched && props.error && <div className={styles.error}>{props.error}</div>}
			</div>
		</div>
	)
};

FileField.defaultProps = {
	disabled: false,
	touched: false,
	required: false
}
